import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import Footer from '@/pages/home/components/Footer';
import { UpdatesSection, ContactSection, CardsSection, FaqSection } from '@/pages/home/components/SectionsGroup1';
import { CarouselSection, RankingSection, AppSection, TopicsSection } from '@/pages/home/components/SectionsGroup2';
import { FeaturesSection, MediaSection, AboutSection, CommentsSection, IndexSection } from '@/pages/home/components/SectionsGroup3';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <ContactSection />
        <CardsSection />
        <FaqSection />
        <CarouselSection />
        <RankingSection />
        <AppSection />
        <TopicsSection />
        <FeaturesSection />
        <MediaSection />
        <AboutSection />
        <CommentsSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}